import React, { useState, useEffect } from 'react';
import CommonInput from '../../Common/CommonInput';

const GeneralSettingsForm = ({ initialData, onSave, isLoading, onClose }) => {
    const [formData, setFormData] = useState({
        prefix_purchase_number: '',
        title: '',
    });

    const [errors, setErrors] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (initialData) {
            setFormData({
                prefix_purchase_number: initialData.prefix_purchase_number || '',
                title: initialData.title || '',
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSaving(true);
            await onSave(formData);
            setErrors({});
        } catch (error) {
            if (error.errors) {
                const newErrors = {};
                Object.keys(error.errors).forEach(key => {
                    newErrors[key] = Array.isArray(error.errors[key])
                        ? error.errors[key][0]
                        : error.errors[key];
                });
                setErrors(newErrors);
            } else {
                setErrors({
                    prefix_purchase_number: error.message || 'An error occurred while saving',
                });
            }
            return;
        } finally {
            setIsSaving(false);
        }
    };

    const isSubmitting = isLoading || isSaving;

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="h-100 d-flex flex-column">
            <div className="d-flex justify-content-between mb-2">
                <div className="d-flex justify-content-start">
                    <h5 className="mb-0">General Settings</h5>
                </div>
            </div>
            <div className="flex-grow-1">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">
                                <CommonInput
                                    name="title"
                                    label="Application Title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                            <div className="col-md-12 d-none">
                                <CommonInput
                                    name="prefix_purchase_number"
                                    label="Purchase Invoice prefix"
                                    value={formData.prefix_purchase_number}
                                    onChange={handleChange}
                                    errors={errors}
                                    required={false}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="form-footer">
                <button
                    type="button"
                    className="btn btn-light"
                    onClick={onClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSaving ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                        </>
                    ) : 'Save'}
                </button>
            </div>
        </form>
    );
};

export default GeneralSettingsForm;
